import axios from 'axios';
import { getToken } from './authService';

const API_URL = process.env.REACT_APP_API_URL;

// Returns the logged-in user's personal Garmin Connect authorization URL.
// The backend provisions the Fitrockr user (if needed) and sets primaryWearable=garmin.
// The user opens this URL, logs into their Garmin account, and authorizes data sharing.
export const getGarminConnectLink = async () => {
    const res = await axios.get(`${API_URL}/fitrockr/connect-link`, {
        headers: { Authorization: `Bearer ${getToken()}` },
    });
    return res.data.url;
};
